/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer, VApplication } from '@/application';
import { ApplicationFormPageService } from '@/pages/ApplicationForm/services';
import { toast } from 'react-hot-toast';

const MODULE_NAME = 'saveApplicantApplication.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

export const saveApplicantApplication = async (context: any, event: any) => {
  console.log(`in saveApplicantApplication state :`, event);
  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const src = getSrv();

      const data: any = await src.agent.saveApplicantApplication(
        event?.payload
      );
      console.log(
        `payload in saveApplicantApplication ::::`,
        event?.payload,
        data
      );
      if (data) {
        console.log(`onSave success:: #2 =>`, data);
        // toast.success(context['SAVE_APPLICANT_APP_SUCCESS'].message);
        return resolve({
          key: 'SAVE_APPLICANT_APP_SUCCESS',
          value: {
            ...(data || {}),
          },
        });
      } else {
        // toast.error(context['SAVE_APPLICANT_APP_ERROR']?.message);
        return reject({
          key: 'SAVE_APPLICANT_APP_ERROR',
          value: 'Failed to submit application',
        });
      }
    } catch (err: any) {
      // toast.error(context['SAVE_APPLICANT_APP_ERROR']?.message);
      return reject({
        key: 'SAVE_APPLICANT_APP_ERROR',
        value: err?.message,
      });
    }
  });
};
